import { BULKTRANSFER } from '../actionTypes';

const initialState = {
  content: [],
  searchResults: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case BULKTRANSFER.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case BULKTRANSFER.SUCCESS_SEARCH:
      return {
        ...state,
        searchResults: action.payload,
      };
    default:
      return state;
  }
};
